import { Center, Flex, HStack, Image, Link, Text } from "@chakra-ui/react";
import homePageImage from "../../assets/image/home-header-original.webp";
import { FaApple, FaGooglePlay } from "react-icons/fa";

function AppImage() {
  return (
    <Flex
      alignItems={"center"}
      flexDirection={"column"}
      gap={["30px", "35px", "45px", "50px", "60px", "60px"]}
    >
      <Center backgroundColor="#FFFFFF" width={"100%"}>
        <Image
          height={"auto"}
          width={["100%", "100%", "100%", "100%", "80%", "65%"]}
          src={homePageImage}
        />
      </Center>
      <Flex
        flexDirection={{ md: "row", base: "column" }}
        gap={"20px"}
        width={"100%"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Flex
          height={{ base: "55px", md: "60px", lg: "70px" }}
          bg="#171717"
          width={{ base: "250px", md: "300px", lg: "400px" }}
          borderRadius={[5, 8, 9, 11, 12, 12]}
          color={"white"}
        >
          <Link
            href={"https://apps.apple.com/us/app/going-solo/id1671515758"}
            target="_blank"
            height={"100%"}
            width={"100%"}
          >
            <Flex
              justifyContent={"center"}
              alignItems={"center"}
              height={"100%"}
              width={"100%"}
            >
              <HStack spacing={2}>
                <FaApple size={35} />

                <Text
                  fontSize={["12px", "14px", "16px", "18px", "18px", "20px"]}
                  style={{ textTransform: "uppercase" }}
                >
                  Download on App Store
                </Text>
              </HStack>
            </Flex>
          </Link>
        </Flex>

        <Flex
          height={{ base: "55px", md: "60px", lg: "70px" }}
          bg="#0F72F0"
          width={{ base: "250px", md: "300px", lg: "400px" }}
          borderRadius={[5, 8, 9, 11, 12, 12]}
          color={"white"}
        >
          <Link
            href={
              "https://play.google.com/store/apps/details?id=com.goingsolo.android"
            }
            target="_blank"
            height={"100%"}
            width={"100%"}
          >
            <Flex
              justifyContent={"center"}
              alignItems={"center"}
              height={"100%"}
              width={"100%"}
            >
              <HStack spacing={2}>
                <FaGooglePlay size={35} />
                <Text
                  fontSize={["12px", "14px", "16px", "18px", "18px", "20px"]}
                  style={{ textTransform: "uppercase" }}
                >
                  Get it on PlayStore
                </Text>
              </HStack>
            </Flex>
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default AppImage;
